export default {
  name: 'gmk-bento',
  override: {
    KC_ESC: 'accent',
    KC_ENT: 'accent',
    KC_RALT: 'accent',
    KC_LALT: 'accent'
  }
};
